import { apiGet } from './client';
import type { AiA2AAgentSkill, OperationResult } from './types';

// Wraps the AiA2AAgentSkillController endpoints. A2A skills are advertised
// to other agents for routing — distinct concept from MAF procedural skills.

export async function getA2ASkillsForAgent(agentId: number): Promise<AiA2AAgentSkill[]> {
  const result = await apiGet<OperationResult<AiA2AAgentSkill[]>>(
    `/api/AiA2AAgentSkill/ForAgent/${agentId}`
  );
  if (!result.isSuccess) throw new Error(result.message || 'Failed to load A2A skills');
  return result.data ?? [];
}

export async function findAgentsByA2ATags(tags: string[]): Promise<number[]> {
  const result = await apiGet<OperationResult<number[]>>(
    '/api/AiA2AAgentSkill/FindAgentsByTags',
    { tags: tags.join(',') }
  );
  if (!result.isSuccess) throw new Error(result.message || 'Failed to query tags');
  return result.data ?? [];
}
